var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6914 8.6L13.9855 9.30588L12.5384 7.85882L13.2443 7.15294C13.3169 7.08181 13.4145 7.04196 13.5161 7.04196C13.6177 7.04196 13.7153 7.08181 13.7879 7.15294L14.6914 8.05647C14.8396 8.20471 14.8396 8.45177 14.6914 8.6ZM7.84432 12.5459L12.122 8.26824L13.569 9.71529L9.29844 14H7.84432V12.5459ZM7.84432 9.05882C4.72432 9.05882 2.19727 10.3224 2.19727 11.8824V13.2941H6.43256V11.96L9.25609 9.13647C8.79021 9.08 8.31727 9.05882 7.84432 9.05882ZM7.84432 2C7.09548 2 6.3773 2.29748 5.84779 2.82699C5.31827 3.35651 5.02079 4.07468 5.02079 4.82353C5.02079 5.57238 5.31827 6.29055 5.84779 6.82007C6.3773 7.34958 7.09548 7.64706 7.84432 7.64706C8.59317 7.64706 9.31135 7.34958 9.84086 6.82007C10.3704 6.29055 10.6679 5.57238 10.6679 4.82353C10.6679 4.07468 10.3704 3.35651 9.84086 2.82699C9.31135 2.29748 8.59317 2 7.84432 2Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAccount);
export default __webpack_public_path__ + "static/media/edit-account.44df1526d4e7791f660e250677fb25a5.svg";
export { ForwardRef as ReactComponent };